"use strict";
function convertIcon(name) {
    if (name === 'Link') {
        return 'linkify';
    }
    if (name === 'Video') {
        return 'video';
    }
    if (name === 'Audio') {
        return 'microphone';
    }
    if (name === 'Document') {
        return 'file';
    }
    if (name === 'Image') {
        return 'file image';
    }
    if (name === 'Tool') {
        return 'wrench';
    }
};

export default convertIcon;